import React from 'react';
import PropTypes from 'prop-types';
import SubmitSpinner from '../../../../../common/Spinners/SubmitSpinner'
import SuccessCheckMessage from '../../../../../common/SuccessCheckMessage'
import { rejectProfile } from './rejectPendingApprovalProfileActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SecondaryActionButton from '../../../../../common/Buttons/SecondaryActionButton'
import history from '../../../../../core/history'

const RejectPendingApprovalProfile = function ({
    profile
    , rejectProfile
    , edited
    , submitting
    , submitted
    , isSubmitting
  }) {
  const message = 'Profile rejected.'
  // Bootstrap 5 greys out href-less anchors (a:not([href]):not([class])); style it as a link so it
  // doesn't read as disabled. #26B0E2 is the app's $link-color.
  const successMsg = <a style={{ color: '#26B0E2', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => history.push('/administration/pendingapprovalAdviserProfiles')}>Return to index.</a>
  // No wrapping <div>: render the button (and its transient spinner/success) directly so it sits
  // as a sibling of the Approve button in the .approval-actions flex row and lines up with it.
  return <React.Fragment>
    { !submitted && <SecondaryActionButton
      buttonText='Reject Profile'
      disabled={isSubmitting}
      onClick={() => { rejectProfile(profile.adviserId) }}
      size={'large'}
      preventDefault /> }
    {submitting && <SubmitSpinner />}
    {submitted && !edited && <SuccessCheckMessage children={successMsg} message={message} />}
  </React.Fragment>
}

RejectPendingApprovalProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  rejectProfile: PropTypes.func.isRequired,
  edited: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    edited: adviserProfileApprovalEditorContainer.edited,
    submitting: adviserProfileApprovalEditorContainer.rejectProfile.submitting,
    submitted: adviserProfileApprovalEditorContainer.rejectProfile.submitted
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    rejectProfile: rejectProfile
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(RejectPendingApprovalProfile)
